import { match } from 'ts-pattern';

import { RichTextContent } from '@telialt/common-rich-text-content/src/RichTextContent';
import { withParams } from '@telialt/utils/src/helpers';

import { ServiceOfferItem } from '../../../model';
import { PlanCardModel } from '../../PlanCard';

export const transformServiceOffersToPlanCardDetails = (items: ServiceOfferItem[]) => {
    return items
        .map((serviceOffer) =>
            (serviceOffer.benefits || []).map((benefit) => {
                return {
                    text: match(benefit.component)
                        .with('DATA_ALLOWANCE_EU', () =>
                            withParams(benefit.name, { data: serviceOffer.dataSizeEuropeTotalFormatted }),
                        )
                        .with('DATA_ALLOWANCE_TD1', () =>
                            withParams(benefit.name, { data: serviceOffer.dataSizeTravelDestinationTotalFormatted }),
                        )
                        .otherwise(() => benefit.name),
                    available: benefit.available,
                    id: `${serviceOffer.id}-${benefit.name}`,
                    modal: {
                        content: <RichTextContent richText={benefit.description} />,
                        imageUrl: benefit.image,
                        imageAlt: '',
                    },
                } as PlanCardModel.Detail;
            }),
        )
        .flat();
};

export const transformServiceOffersToPlanCardDescriptions = (items: ServiceOfferItem[]) => {
    return items
        .map((serviceOffer) =>
            (serviceOffer.vas || []).map((vas) => {
                return {
                    term: vas.name,
                    detail: vas.note,
                    id: `${serviceOffer.id}-${vas.name}`,
                    modal: {
                        content: <RichTextContent richText={vas.description} />,
                        imageUrl: vas.image,
                        imageAlt: '',
                    },
                } as PlanCardModel.Description;
            }),
        )
        .flat();
};
